const pagination = () => {
  const updatePagin = (target, step) => {
    const firstElem = target.children[0];
    const elemWidth = firstElem.offsetWidth;
    const elemsLength = target.children.length;
    const targetLimit = target.classList.contains('is-big') ? 3 : 4;
    if (firstElem.style.marginLeft === '') {
      firstElem.style.marginLeft = 0;
    }
    if (step < 0 && parseInt(firstElem.style.marginLeft, 10) !== 0) {
      firstElem.style.marginLeft = `${parseInt(firstElem.style.marginLeft, 10) +
        elemWidth}px`;
    }
    if (
      step > 0 &&
      Math.abs(parseInt(firstElem.style.marginLeft, 10)) !==
        (elemsLength - targetLimit) * elemWidth
    ) {
      firstElem.style.marginLeft = `${parseInt(firstElem.style.marginLeft, 10) -
        elemWidth}px`;
    }
  };

  const pagin = document.querySelectorAll('.js-pagination');
  if (pagin.length) {
    pagin.forEach(pager => {
      const target = pager.parentElement.querySelector('.js-pagination-target');
      const limit = target.classList.contains('is-big') ? 3 : 4;
      if (target.children.length <= limit) {
        pager.classList.add('u-hidden');
      }
      pager.querySelector('.js-prev').addEventListener('click', () => {
        updatePagin(target, -1);
      });
      pager.querySelector('.js-next').addEventListener('click', () => {
        updatePagin(target, 1);
      });
    });
  }
};
export default pagination;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/bnppblog-chisel/src/scripts/modules/pagination.js